import { render, staticRenderFns } from "./submitVchicle.vue?vue&type=template&id=5bc98af9&scoped=true"
import script from "./submitVchicle.vue?vue&type=script&setup=true&lang=js"
export * from "./submitVchicle.vue?vue&type=script&setup=true&lang=js"
import style0 from "./submitVchicle.vue?vue&type=style&index=0&id=5bc98af9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc98af9",
  null
  
)

export default component.exports